import React, { useEffect, useState } from "react";
import {
  IconBad,
  IconBadFill,
  IconGood,
  IconGoodFill,
  IconNormal,
  IconNormalFill,
  IconVeryBad,
  IconVeryBadFill,
  IconVeryGood,
  IconVeryGoodFill,
} from "../../../assets/icon";

const EmotionRate = ({ setAnswer, data, setErrorAll }) => {
  const [listOption, setListOption] = useState([
    {
      value: 1,
      icon: <IconVeryBad />,
      iconfill: <IconVeryBadFill />,
      label: "Rất không hài lòng",
      status: "inactive",
    },
    {
      value: 2,
      icon: <IconBad />,
      iconfill: <IconBadFill />,
      label: "Không hài lòng",
      status: "inactive",
    },
    {
      value: 3,
      icon: <IconNormal />,
      iconfill: <IconNormalFill />,
      label: "Bình thường",
      status: "inactive",
    },
    {
      value: 4,
      icon: <IconGood />,
      iconfill: <IconGoodFill />,
      label: "Hài lòng",
      status: "inactive",
    },
    {
      value: 5,
      icon: <IconVeryGood />,
      iconfill: <IconVeryGoodFill />,
      label: "Rất hài lòng",
      status: "inactive",
    },
  ]);
  const handleClick = (value, index) => {
    if (value.value === index + 1 && value.status === "active") {
      setAnswer([
        {
          answer: 0,
        },
      ]);
    }

    if (value.value === index + 1 && value.status === "inactive") {
      setAnswer([
        {
          answer: value.value,
        },
      ]);
    }
  };
  useEffect(() => {
    let index;
    listOption.map((item, i) =>
      item.label === data.answer || item.value === data.answer
        ? (index = i)
        : null
    );
    const result = listOption.map((item, indexItem) => {
      if (indexItem <= index) {
        return {
          ...item,
          status: "active",
        };
      } else {
        return {
          ...item,
          status: "inactive",
        };
      }
    });
    setListOption(result);
  }, [data.answer]);
  return (
    <div>
      <div className="wrapperEmotion">
        {listOption.map((item, index) => {
          return (
            <div
              className="emotionItem"
              onClick={() => handleClick(item, index)}
            >
              {item.status === "inactive" ? item.icon : item.iconfill}
              <span className="labelEmotion">{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmotionRate;
